module.exports = __webpack_public_path__ + "img/Back to top button.d84d98b1.png";